import i18n from "../common/lang";

//计算秒数
export function SecondToDate(msd) {
    var time = msd;
    if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
            time =
                parseInt(time / 60.0) +
                i18n.t("lang.particulars.minutes") +
                parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) +
                i18n.t("lang.particulars.seconds");
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
            time =
                parseInt(time / 3600.0) +
                i18n.t("lang.particulars.hours") +
                parseInt(
                    (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                ) +
                i18n.t("lang.particulars.minutes") +
                parseInt(
                    (parseFloat(
                        (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                        ) -
                        parseInt(
                            (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                        )) *
                    60
                ) +
                i18n.t("lang.particulars.seconds");
        } else if (time >= 60 * 60 * 24) {
            time =
                parseInt(time / 3600.0 / 24) +
                i18n.t("lang.particulars.Day") +
                parseInt(
                    (parseFloat(time / 3600.0 / 24) - parseInt(time / 3600.0 / 24)) *
                    24
                ) +
                i18n.t("lang.particulars.hours") +
                parseInt(
                    (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                ) +
                i18n.t("lang.particulars.minutes") +
                parseInt(
                    (parseFloat(
                        (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                        ) -
                        parseInt(
                            (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                        )) *
                    60
                ) +
                i18n.t("lang.particulars.seconds");
        } else {
            time = parseInt(time) + i18n.t("lang.particulars.seconds");
        }
    }
    return time;
}

//计算毫秒数
export function getDuration(mss) {
    let days = parseInt(mss / (1000 * 60 * 60 * 24));
    let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = parseInt((mss % (1000 * 60)) / 1000);
    return (
        days +
        i18n.t("lang.particulars.Day") +
        hours +
        i18n.t("lang.particulars.hours") +
        minutes +
        i18n.t("lang.particulars.minutes") +
        seconds +
        i18n.t("lang.particulars.seconds")
    );
}

// 计算流量
export function getOnlineTime(byte) {
  let result = ''
  if(byte !== undefined) {
    let kb = 0
    let mb = 0
    let g = 0
    if(byte > 1024) {
      kb = byte / 1024
    }
    if(kb > 1024) {
      mb = kb / 1024 
    }
    if(mb > 1024) {
      g = mb / 1024
    }
    if(g !== 0) {
      result = Math.floor(g * 10) / 10 + 'G'
    }else if(mb !== 0) {
      result = Math.floor(mb * 10) / 10 + 'M'
    }else if(kb !== 0) {
      result = Math.floor(kb * 10) / 10 + 'K'
    }else if(byte !== 0){
      result = byte + 'B'
    }else{
      result = '0'
    }
  }
  return result
}